import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import React from 'react';
import { FormFeedback } from 'reactstrap';

import CustomFormField from '../../../models/CustomFormField';
import FormField from '../../../models/FormField';
import { modelOf } from '../../../prop-types';

const FieldError = ({ field, customError }) => {
  const getError = () => {
    let error = null;

    if (field?.errors?.length > 0) {
      error = field.errors[0];
    }

    if (customError) {
      error = customError;
    }

    return error;
  };

  const error = getError();

  if (!error) {
    return null;
  }

  return <FormFeedback className="FieldError">{error}</FormFeedback>;
};

FieldError.propTypes = {
  field: PropTypes.oneOfType([modelOf(FormField), modelOf(CustomFormField)]),
  customError: PropTypes.string,
};

export default observer(FieldError);
